class StationCoverageZone {
  constructor(title, fenceColor, stationId, stationCoverageZoneFences) {
    this.title = title;
    this.fenceColor = fenceColor;
    this.stationId = stationId;
    this.stationCoverageZoneFences = stationCoverageZoneFences;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      stationCoverageZoneId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      stationId: null,
      fenceModal: false,
      colorValue: '#1976D2FF',
      currentFenceColor: '#1976D2FF',
      showColorPicker: false,
      colorPickerMode: 'hexa',
      mask: '!#XXXXXXXX',
      text: 'skbfhsd',
      menu: false,
      drawLayer: null,
      addFanceCordsLatLng: [],
      stationHasFance: false,
      currentFenceCoords: [],
      otherFenceCoords: [],
      hasOtherFence: false,
      currentFenceLayer: null,
      toggleEditFlag: false,
      //lake
      lakeModal: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        this.addFlag = true;
        this.showAddModal();
      } else if (type == 2) {
        this.confimType = 'edit';
        this.addFlag = false;
        this.getStationCoverageZoneFunction(id);
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addStationCoverageZoneFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش فنس منطقه';
        this.$refs.confirm.text = 'از ویرایش فنس منطقه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف فنس منطقه';
        this.$refs.confirm.text = 'از حذف فنس منطقه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'deleteLake') {
        this.$refs.confirm.title = 'حذف فاقدی';
        this.$refs.confirm.text = 'از حذف فاقدی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addStationCoverageZoneFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editStationCoverageZoneFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteStationCoverageZoneFunction();
      } else if (this.confimType == 'deleteLake') {
        this.disabelConfirm = true;
        this.deleteStationCoverageZoneSupportStationFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'deleteLake') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.stationCoverageZoneId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //delete lake
    showDeleteLakeConfirmFunction: function (id) {
      this.stationCoverageZoneSupportStationId = id;
      this.confimType = 'deleteLake';
      this.showConfirmDialogFunction();
    },
    //fence
    closeStationCoverageZone: function () {
      const map = this.$refs.fancemap.mapObject;
      //map.removeLayer(this.polygon);
      for (let i in map._layers) {
        if (map._layers[i]._path != undefined) {
          try {
            map.removeLayer(map._layers[i]);
          } catch (e) {
            this.snackText = e;
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        }
      }
      this.colorValue = '#1976D2FF';
      this.stationCoverageZone = new StationCoverageZone('', '', this.stationId, []);
      this.fenceModal = false;
      this.hasOtherFence = false;
      this.addFlag = true;
      this.stationHasFance = false;
      this.toggleEditFlag = false;
    },
    showEditModal: function (currentFence) {
      this.fanceMapInvalidate();
      this.hasOtherFence = true;
      this.toggleEditFlag = true;
      this.otherFenceCoords = [];
      for (let i = 0; i < this.allStationCoverageZonesForFence.length; i++) {
        let tempFence = {
          latlngs: [],
          color: this.allStationCoverageZonesForFence[i].fenceColor,
        };
        if (currentFence.id != this.allStationCoverageZonesForFence[i].id) {
          for (
            let j = 0;
            j < this.allStationCoverageZonesForFence[i].stationCoverageZoneFences.length;
            j++
          ) {
            let data = [];
            data.push(
              this.allStationCoverageZonesForFence[i].stationCoverageZoneFences[j].latitude,
            );
            data.push(
              this.allStationCoverageZonesForFence[i].stationCoverageZoneFences[j].longitude,
            );
            tempFence.latlngs.push(data);
          }
          this.otherFenceCoords.push(tempFence);
        }
      }
      /*this.$nextTick(() => {
                const map = this.$refs.fancemap.mapObject;
                map.pm.setLang('fa');
                map.on('pm:remove', ({ layer }) => {
                    this.removeFance(layer);
                });
                map.pm.addControls({
                    position: 'bottomleft',
                    drawCircle: false,
                    drawRectangle: false,
                    drawPolyline: false,
                    editMode: false,
                    cutPolygon: false,
                    drawCircleMarker: false,
                    drawMarker: false,
                    optionsControls: false,
                    removalMode: false,
                    dragMode: false,
                    drawText: false,
                    rotateMode: false,
                    drawPolygon: false,
                });
            })*/
    },
    showAddModal: function () {
      this.fenceModal = true;
      this.fanceMapInvalidate();
      if (this.allStationCoverageZonesForFence.length == 0) {
        this.$nextTick(() => {
          const map = this.$refs.fancemap.mapObject;
          map.pm.setLang('fa');
          map.on('pm:create', ({ layer }) => {
            this.drawFanse(layer);
          });
          map.pm.addControls({
            position: 'bottomleft',
            drawCircle: false,
            drawRectangle: false,
            drawPolyline: false,
            editMode: false,
            cutPolygon: false,
            drawCircleMarker: false,
            drawMarker: false,
            optionsControls: false,
            removalMode: false,
            dragMode: false,
            drawText: false,
            rotateMode: false,
            drawPolygon: true,
          });
        });
      } else {
        this.hasOtherFence = true;
        this.otherFenceCoords = [];
        for (let i = 0; i < this.allStationCoverageZonesForFence.length; i++) {
          let tempFence = {
            latlngs: [],
            color: this.allStationCoverageZonesForFence[i].fenceColor,
          };
          for (
            let j = 0;
            j < this.allStationCoverageZonesForFence[i].stationCoverageZoneFences.length;
            j++
          ) {
            let data = [];
            data.push(
              this.allStationCoverageZonesForFence[i].stationCoverageZoneFences[j].latitude,
            );
            data.push(
              this.allStationCoverageZonesForFence[i].stationCoverageZoneFences[j].longitude,
            );
            tempFence.latlngs.push(data);
          }
          this.otherFenceCoords.push(tempFence);
        }
        this.$nextTick(() => {
          const map = this.$refs.fancemap.mapObject;
          map.pm.setLang('fa');
          map.on('pm:create', ({ layer }) => {
            this.drawFanse(layer);
          });
          map.pm.addControls({
            position: 'bottomleft',
            drawCircle: false,
            drawRectangle: false,
            drawPolyline: false,
            editMode: false,
            cutPolygon: false,
            drawCircleMarker: false,
            drawMarker: false,
            optionsControls: false,
            removalMode: false,
            dragMode: false,
            drawText: false,
            rotateMode: false,
            drawPolygon: true,
          });
        });
      }
    },
    drawFanse: function (layer) {
      this.drawLayer = layer;
      this.toggleEditFlag = true;
      this.currentFenceLayer = layer;
      var coords = layer.getLatLngs();
      this.addFanceCordsLatLng = coords;
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:remove', ({ layer }) => {
          this.removeFance(layer);
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: false,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: false,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: false,
        });
      });
    },
    /*removeFance: function (layer) {
            this.drawLayer = layer;
            this.addFanceCordsLatLng = [];
            this.$nextTick(() => {
                const map = this.$refs.fancemap.mapObject;
                map.pm.setLang('fa');
                map.on('pm:create', ({ layer }) => {
                    this.drawFanse(layer);
                });
                map.pm.addControls({
                    position: 'bottomleft',
                    drawCircle: false,
                    drawRectangle: false,
                    drawPolyline: false,
                    editMode: false,
                    cutPolygon: false,
                    drawCircleMarker: false,
                    drawMarker: false,
                    optionsControls: false,
                    removalMode: false,
                    dragMode: false,
                    drawText: false,
                    rotateMode: false,
                    drawPolygon: true,
                });
            })
        },*/
    /*editFance: function (layer) {
            this.drawLayer = layer;
            var coords = layer.getLatLngs();
            this.addFanceCordsLatLng = coords;
            this.$nextTick(() => {
                const map = this.$refs.fancemap.mapObject;
                map.pm.setLang('fa');
                map.on('pm:remove', ({ layer }) => {
                    this.removeFance(layer);
                });
                map.on('pm:globaleditmodetoggled', e => {
                    e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
                        this.editFance(layer);
                    });
                });
                map.pm.addControls({
                    position: 'bottomleft',
                    drawCircle: false,
                    drawRectangle: false,
                    drawPolyline: false,
                    editMode: true,
                    cutPolygon: false,
                    drawCircleMarker: false,
                    drawMarker: false,
                    optionsControls: false,
                    removalMode: true,
                    dragMode: false,
                    drawText: false,
                    rotateMode: false,
                    drawPolygon: false,
                });
            })
        },*/
    //lake part
    showLakeModal: function (id) {
      this.getListOfStationsForOther();
      this.stationCoverageZoneId = id;
      this.getAllStationCoverageZoneSupportStations(id);
      this.lakeModal = true;
    },
    closeStationLakeModal: function () {
      this.cleanLakeForm();
      this.lakeModal = false;
    },
    readyCurrentLayer: function (event) {
      this.toggleEditFlag = true;
      this.currentFenceLayer = event;
    },
    toggleEditMode: function () {
      if (this.currentFenceLayer.pm._enabled == true) {
        let coords = this.currentFenceLayer.getLatLngs();
        this.addFanceCordsLatLng = coords;
        this.currentFenceLayer.pm.disable();
      } else {
        this.currentFenceLayer.pm.enable();
      }
    },
    backTopage: function () {
      this.$router.push({ name: 'station' });
    },
  },
};
